import { usePreferences } from '../../hooks'
import { useWidgetLoader } from './useWidgetLoader'
import { WidgetConnectionsV3 } from './WidgetConnectionsV3'
import { WidgetConnectionsV2 } from './WidgetConnectionsV2'
import { WidgetConnectionsLoading } from './WidgetConnectionsLoading'
import { WidgetConnectionsError } from './WidgetConnectionsError'
import { ConnectionsLayout } from './ConnectionsLayout'
import type { HotglueConnectionsProps, WidgetConnectionsV2Props } from './types'

function WidgetConnectionsV2Wrapper({
  widgetModule,
  data,
}: WidgetConnectionsV2Props) {
  const { HotglueConfig } = widgetModule
  const v2Options = {
    ...data.options,
    ...(data.jwt ? { jwtToken: data.jwt } : {}),
  }
  return (
    <HotglueConfig
      config={{
        envId: data.envId,
        apiKey: data.apiKey,
        options: v2Options,
      }}
    >
      <WidgetConnectionsV2
        widgetModule={widgetModule}
        data={data}
      />
    </HotglueConfig>
  )
}

export function HotglueConnections({
  data,
  connectorComponentStyle,
}: HotglueConnectionsProps) {
  const hasConnectorComponentStyle = Boolean(connectorComponentStyle)
  const {
    magicLinkWidgetVersion,
    isLoading: preferencesLoading,
  } = usePreferences(data.envId, data.apiKey)

  const { widgetModuleV3, widgetModuleV2, moduleError } = useWidgetLoader(
    magicLinkWidgetVersion,
    preferencesLoading
  )

  if (preferencesLoading) {
    return (
      <ConnectionsLayout
        hasConnectorComponentStyle={hasConnectorComponentStyle}
      >
        <WidgetConnectionsLoading />
      </ConnectionsLayout>
    )
  }

  if (moduleError) {
    return (
      <ConnectionsLayout
        hasConnectorComponentStyle={hasConnectorComponentStyle}
      >
        <WidgetConnectionsError message={moduleError} />
      </ConnectionsLayout>
    )
  }

  if (!widgetModuleV3 && !widgetModuleV2) {
    return (
      <ConnectionsLayout
        hasConnectorComponentStyle={hasConnectorComponentStyle}
      >
        <WidgetConnectionsLoading />
      </ConnectionsLayout>
    )
  }

  return (
    <ConnectionsLayout
      hasConnectorComponentStyle={hasConnectorComponentStyle}
    >
      {widgetModuleV3 && (
        <WidgetConnectionsV3
          widgetModule={widgetModuleV3}
          data={data}
          connectorComponentStyle={connectorComponentStyle}
        />
      )}
      {widgetModuleV2 && (
        <WidgetConnectionsV2Wrapper
          widgetModule={widgetModuleV2}
          data={data}
        />
      )}
    </ConnectionsLayout>
  )
}
